/**
 * 是否为客户端，即非服务端渲染
 */
export var isClient = typeof window !== 'undefined';
/**
 * 是否为服务端
 */
export var isServer = typeof window === 'undefined';
/**
 * 是否处于app内
 */
export var isApp = isClient && typeof window.goods !== 'undefined';
/**
 * 检查是否处于app内
 * 防止window.goods在页面加载时尚未就绪，可以手动调用该方法
 */
export function checkIsApp() {
    return isClient && window.goods !== 'undefined';
}
export var isString = function (val) { return typeof val === 'string'; };
export var isObject = function (val) {
    return val !== null && typeof val === 'object';
};
export var isNullObject = function (val) { return Object.keys(val).length === 0; };
export var isArray = function (val) {
    return Object.prototype.toString.call(val) === '[object Array]';
};
export var isFunction = function (val) {
    return Object.prototype.toString.call(val) === '[object Function]';
};
export var isDef = function (val) { return val !== undefined && val !== null; };
export var isUndef = function (val) { return val === undefined || val === null; };
var u = isClient ? navigator.userAgent : '';
export var isIos = /ipad|iphone|mac/i.test(u);
export var isAndroid = /android/i.test(u);
export var isWechat = /micromessenger/i.test(u);
/**
 * 获取当前页面url，会自动移除#后的参数
 */
export function getUrl() {
    return isClient ? location.href.split('#')[0] : '';
}
/**
 * 处理参数
 */
export var queryString = {
    /**
     * 把对象转换为字符串
     * @param params 参数对象
     * @returns {string}
     */
    stringify: function (params) {
        var resArr = [];
        for (var key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key)) {
                // @ts-ignore
                resArr.push("".concat(key, "=").concat(params[key]));
            }
        }
        return resArr.join('&');
    },
    /**
     * 把参数字符串转换为对象
     * @param {string} str 参数字符串
     * @returns {Object}
     */
    parse: function (str) {
        if (!str)
            return str;
        var res = {};
        var arr = str.split('&');
        arr.forEach(function (item) {
            var _a = item.split('='), key = _a[0], value = _a[1];
            res[key] = value;
        });
        return res;
    }
};
/**
 * 处理url地址中的参数
 */
export var urlQueryString = {
    /**
     * 把对象转换为字符串并拼接到url中，已存在的参数会被覆盖
     * @param url url地址
     * @param params 参数对象
     */
    stringify: function (url, params) {
        var _url = url.split('#')[0];
        var searchObj = {};
        if (~url.indexOf('?')) {
            var _a = url.split('?'), __url = _a[0], __search = _a[1];
            _url = __url;
            searchObj = queryString.parse(__search);
        }
        var _search = queryString.stringify(Object.assign({}, searchObj, params));
        return _url + '?' + _search;
    },
    /**
     * 截取url中问号后面的参数，并转换为对象
     * @param {string} url url地址
     */
    parse: function (url) {
        var _url = url.split('#')[0];
        var _search = {};
        if (~url.indexOf('?')) {
            var _a = url.split('?'), __url = _a[0], __search = _a[1];
            _url = __url;
            _search = queryString.parse(__search);
        }
        return {
            url: _url,
            search: _search
        };
    }
};
export var queryStringArgsCached;
/**
 * 解析url search
 */
export function getQueryStringArgs(urlSearch) {
    var qs = urlSearch.length > 0 ? urlSearch.split('?')[1] : '';
    if (!qs) {
        return {};
    }
    var args = Object.create(null);
    var items = qs.length ? qs.split('&') : [];
    var item = null;
    var name = null;
    var value = null;
    var i = 0;
    var len = items.length;
    var regx = new RegExp('(.*)=([^$].*)$', 'i');
    for (i = 0; i < len; i++) {
        item = items[i].match(regx);
        if (!item) {
            continue;
        }
        // decodeURIComponent解码
        name = decodeURIComponent(item[1]).toLowerCase();
        // 移除某些版本的意外字符（换行符）
        var s = item[2].replace(/%0A/g, '');
        value = decodeURIComponent(s);
        if (name.length && !args[name]) {
            args[name] = value;
        }
    }
    return args;
}
export function getSearchQueryString() {
    if (isServer) {
        return {};
    }
    if (queryStringArgsCached) {
        return queryStringArgsCached;
    }
    var args = getQueryStringArgs(location.search);
    queryStringArgsCached = args;
    return args;
}
export function getHashQueryString() {
    if (isServer) {
        return {};
    }
    return getQueryStringArgs(location.hash);
}
/**
 * 获取文档高度
 */
export function getDocumentHeight() {
    var body = document.body;
    var html = document.documentElement;
    return Math.max(body.offsetHeight, body.scrollHeight, html.clientHeight, html.offsetHeight, html.scrollHeight);
}
/**
 * 从url中获取参数
 * @param name 参数名
 * @returns 对应的值
 */
export function getParam(name) {
    // 转换为小写
    name = name.toLowerCase();
    var result = queryStringArgsCached
        ? queryStringArgsCached[name]
        : getSearchQueryString()[name];
    if (isUndef(result)) {
        // 尝试从hash中获取参数
        result = getHashQueryString()[name];
    }
    return result;
}
/**
 * 延时函数
 * @param ms 时间毫秒
 */
export function sleep(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
/**
 * 日期格式化
 */
export function formatDate(date, formatStr) {
    var _date = date;
    var str = formatStr;
    var Week = ['日', '一', '二', '三', '四', '五', '六'];
    str = str.replace(/yyyy|YYYY/, _date.getFullYear());
    str = str.replace(/yy|YY/, _date.getYear() % 100 > 9
        ? (_date.getYear() % 100).toString()
        : '0' + (_date.getYear() % 100));
    str = str.replace(/MM/, _date.getMonth() + 1 > 9
        ? (_date.getMonth() + 1).toString()
        : '0' + (_date.getMonth() + 1));
    str = str.replace(/M/g, _date.getMonth() + 1);
    str = str.replace(/w|W/g, Week[_date.getDay()]);
    str = str.replace(/dd|DD/, _date.getDate() > 9 ? _date.getDate().toString() : '0' + _date.getDate());
    str = str.replace(/d|D/g, _date.getDate());
    str = str.replace(/hh|HH/, _date.getHours() > 9 ? _date.getHours().toString() : '0' + _date.getHours());
    str = str.replace(/h|H/g, _date.getHours());
    str = str.replace(/mm/, _date.getMinutes() > 9
        ? _date.getMinutes().toString()
        : '0' + _date.getMinutes());
    str = str.replace(/m/g, _date.getMinutes());
    str = str.replace(/ss|SS/, _date.getSeconds() > 9
        ? _date.getSeconds().toString()
        : '0' + _date.getSeconds());
    str = str.replace(/s|S/g, _date.getSeconds());
    return str;
}
//# sourceMappingURL=utils.js.map